import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';

import SingleRowRight from '../../../assets/img/icons/single-row-right.svg';
import { CUSTOMER_DASHBOARD, NAVIGATION_DATA_TYPES, ROUTES } from '../../../constants';
import { setNavigationState } from '../../../redux';
import TPALegend from './TPALegend';
import { isEmpty } from 'lodash';
import { CircleSpinner } from '../../../assets/svg';

const CustomerTPABox = ({ tpaData, isLoading }) => {
    const dispatch = useDispatch();
    const memoizedTpaData = useMemo(() => tpaData, [tpaData]);
    const onClickPlatform = (platformDetails) => {
        dispatch(setNavigationState({ ...platformDetails, type: NAVIGATION_DATA_TYPES.PLATFORM }));
    };

    return (
        <div className='flex w-100 '>
            <div className='top-right ssc-shadow h-100 '>
                <div className='d-flex flex-wrap align-items-center justify-content-between mb-4 position-relative'>
                    <h3 className='mb-0'>{CUSTOMER_DASHBOARD.PLATFORMS}</h3>
                    <TPALegend />
                </div>
                <div className='d-flex gap-2 flex-wrap position-relative'>
                    {!isEmpty(memoizedTpaData)
                        ? memoizedTpaData.map((e) => {
                              const box_class_name = `w-100 label-box ${e.grade ?? 'grey'}-label d-flex align-items-center justify-content-between`;
                              const dot_class_name = `${e.grade ?? 'grey'}-dot dot me-3`;

                              return (
                                  <div key={e.id} className='platform-tab'>
                                      <Link
                                          onClick={() => onClickPlatform(e)}
                                          to={ROUTES.CUSTOMER.SCORE_CARD_REPORT}
                                          className='text-decoration-none'
                                      >
                                          <div className={box_class_name}>
                                              <div className='d-flex align-items-center'>
                                                  <div className={dot_class_name}></div>
                                                  <span>{e.name}</span> <sup>{'®'}</sup>
                                              </div>
                                              <img
                                                  src={SingleRowRight}
                                                  alt='icon'
                                                  width='10'
                                                  height='15'
                                              />
                                          </div>
                                      </Link>
                                  </div>
                              );
                          })
                        : CUSTOMER_DASHBOARD.PLATFORMS_NOT_FOUND}
                    {isLoading && isEmpty(memoizedTpaData) && (
                        <CircleSpinner absolute size='2.5rem' />
                    )}
                </div>
            </div>
        </div>
    );
};

CustomerTPABox.propTypes = {
    tpaData: PropTypes.array.isRequired,
};

export default CustomerTPABox;
